<main class="dialog-container">
  <section class="dialog-header">
    <h2 mat-dialog-title>{{ data.dialogHeader }}</h2>
    <mat-icon (click)="onCancel()">clear</mat-icon>
  </section>
  <mat-dialog-content class="dialog-content">
    <p>{{ data.dialogContent }}</p>
    @if (data.amountAllocateBalance !== undefined) {
      <p>
        There is {{ data.amountAllocateBalance | customCurrency }} remaining for
        allocation
      </p>
    }
    <form [formGroup]="applicationStatusForm" class="form">
      @if (data.dialogHeader === applicationDeclineTitle) {
        <mat-form-field appearance="outline">
          <mat-label>Reason</mat-label>
          <mat-select
            formControlName="declineReason"
            placeholder="Select a reason"
          >
            @for (reason of data.declinedReasons; track reason) {
              <mat-option [value]="reason">
                {{ reason }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (data.dialogHeader === terminateBursaryTitle) {
        <mat-form-field appearance="outline">
          <mat-label>Reason</mat-label>
          <mat-select
            formControlName="terminateReason"
            placeholder="Select a reason"
          >
            @for (reason of data.declinedReasons; track reason) {
              <mat-option [value]="reason">
                {{ reason }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (
        (applicationStatusForm.get("declineReason")?.value === status.OTHER ||
          applicationStatusForm.get("terminateReason")?.value ===
            status.OTHER) &&
        data.dialogHeader !== amendBursaryAmountTitle
      ) {
        <mat-form-field appearance="outline">
          <mat-label>Other reason</mat-label>
          <input
            matInput
            formControlName="motivation"
            placeholder="Input reason"
          />
        </mat-form-field>
      }
      @if (data.dialogHeader == amendBursaryAmountTitle) {
        <mat-form-field appearance="outline" class="form-field">
          <span matPrefix id="prefix">R &nbsp;</span>
          <mat-label class="label">Bursary amount</mat-label>
          <input matInput formControlName="amendedAmount" type="number" />
          @if (
            applicationStatusForm.get("amendedAmount")?.hasError("required")
          ) {
            <mat-error>
              {{ errorMessages.AMOUNT_REQUIRED }}
            </mat-error>
          }
          @if (applicationStatusForm.get("amendedAmount")?.hasError("min")) {
            <mat-error>
              {{ errorMessages.MINIMUM_AMOUNT_REQUIRED + data.minAmount }}
            </mat-error>
          }
          @if (
            applicationStatusForm.get("amendedAmount")?.hasError("max") &&
            hasMaxAmount
          ) {
            <mat-error>
              {{ errorMessages.MAXIMUM_AMOUNT_REQUIRED + data.maxAmount }}
            </mat-error>
          }
          @if (
            applicationStatusForm
              .get("amendedAmount")
              ?.hasError("allocationExceeded")
          ) {
            <mat-error>
              {{ errorMessages.ALLOCATION_AMOUNT_EXCEEDED }}
            </mat-error>
          }
        </mat-form-field>
      }
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-button color="accent" (click)="onCancel()">
      {{ cancelButton }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="rejectStudent()"
      [disabled]="isButtonDisabled()"
    >
      {{ confirmButton }}
    </button>
  </mat-dialog-actions>
</main>
